import {
  objKeySort
} from '@/util/ajaxsign'
export const tableOption = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: false,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: false,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 200,
  index: false,
  column: [{
      label: '',
      prop: 'id',
      width: 40,
      solt: true
    },
    {
      label: '账号',
      prop: 'account',
      overHidden: true,
    }, {
      label: '姓名',
      prop: 'name',
      overHidden: true,
    }, {
      label: '部门',
      prop: 'deptName',
      overHidden: true,
    }, {
      label: '电话',
      prop: 'phone',
      overHidden: true,
    }, {
      label: '角色',
      prop: 'roleNames',
      overHidden: true
    }, {
      label: '状态',
      prop: 'status',
      formatter: status,
      overHidden: true,
    }, {
      label: '创建时间',
      prop: 'createtime',
      overHidden: true,
      type: 'date',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss'
    }
  ]
}

//设置权限列表操作

//筛选展示
export const roleOption = {
  submitBtn: false,
  emptyBtn: false,
  column: [{
    label: '区域',
    span: 6,
    placeholder: '请选择区域信息',
    prop: "assetAddressTypeCode",
    type: 'select',
    props: {
      label: 'addressTypeName',
      value: 'addressTypeCode'
    },
    dicUrl: '/asset/addressType/getAddressType',
  }]
}

//师傅列表信息
export const workerstable = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: true,
  delBtn: true,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 290,
  index: false,
  column: [{
      label: '',
      prop: 'userId',
      width: 40,
      solt: true
    },
    {
      label: '师傅姓名',
      prop: 'userName',
      minWidth: 100,
      overHidden: true,
    }, {
      label: '手机号码',
      prop: 'phone',
      minWidth: 120,
      overHidden: true,
    }, {
      label: '身份证名称',
      prop: 'cardUserName',
      minWidth: 100,
      overHidden: true,
    }, {
      label: '身份证号码',
      prop: 'cardNum',
      minWidth: 150,
      formatter: cardUser,
      overHidden: true,
    }, {
      label: '工种',
      prop: 'workTypeIds',
      overHidden: true,
      solt: true
    }, {
      label: '冻结状态',
      prop: 'status',
      formatter: isworkstate,
      minWidth: 80
    }, {
      label: '实名状态',
      prop: 'workerState',
      minWidth: 80,
      formatter: isworkerState,
    }, {
      label: '团队认证',
      prop: 'isForeman',
      minWidth: 80,
      formatter: Foremanstate
    }, {
      label: '登记时间',
      prop: 'createtime',
      type: 'date',
      minWidth: 160,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss'
    }
  ]
}

//企业列表
export const companytable = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: true,
  delBtn: true,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 290,
  index: false,
  searchShow: true,
  searchLabelWidth: '80',
  search: {
    prop: 'condition',
    label: '关键字',
    searchPlaceholder: '企业名称、营业执照编码'
  },
  column: [{
      label: '',
      prop: 'id',
      width: 50,
      align: 'center',
      solt: true
    },
    {
      label: '企业名称',
      prop: 'name',
      overHidden: true
    },
    {
      label: '管理员',
      prop: 'userName',
      minWidth: 120,
      overHidden: true,
    }, {
      label: '营业执照编码',
      prop: 'taxNum',
      minWidth: 200,
      overHidden: true,
    }, {
      label: '企业状态',
      prop: 'state',
      minWidth: 80,
      formatter: conpamystate
    }, {
      label: '注册时间',
      prop: 'createTime',
      type: 'date',
      minWidth: 160,
      overHidden: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss'
    }, {
      label: '认证时间',
      prop: 'authTime',
      type: 'date',
      minWidth: 160,
      overHidden: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss'
    }
  ]
}

//员工列表
export const personnel = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: true,
  delBtn: true,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 290,
  index: false,
  searchLabelWidth: '80',
  search: {
    prop: 'condition',
    label: '关键字',
    searchPlaceholder: '姓名、手机号、企业名称、部门'
  },
  column: [{
      label: '',
      prop: 'id',
      width: 40,
      solt: true
    },
    {
      label: '员工姓名',
      prop: 'name',
      minWidth: 120,
      overHidden: true
    }, {
      label: '手机号码',
      prop: 'phone',
      minWidth: 120,
      overHidden: true
    }, {
      label: "所属部门",
      prop: "deptName",
      overHidden: true,
      dicUrl: '/dept/tree',
      dicMethod: "post",
      dicQuery: objKeySort({}),
      props: {
        label: 'name',
        value: 'id'
      }
    }, {
      label: '是否加入企业',
      prop: 'companyAuthStatus',
      overHidden: true,
      minWidth: 120,
      formatter: companystate
    }, {
      label: '管理角色',
      prop: 'isAdminRole',
      overHidden: true,
      search: true,
      type: 'select',
      minWidth: 60,
      formatter: isAdminRoleFormatter
    },{
      label: '状态',
      prop: 'status',
      overHidden: true,
      search: true,
      type: 'select',
      minWidth: 60,
      dicData: [{
          label: '正常',
          value: 1
        },
        {
          label: '冻结',
          value: 2
        }
      ]
      // formatter: personnerstate
    }, {
      label: '注册时间',
      prop: 'createtime',
      type: 'date',
      minWidth: 160,
      overHidden: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss'
    }
  ]
}

export const personnelall = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: true,
  delBtn: true,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 290,
  index: false,
  searchLabelWidth: '80',
  search: {
    prop: 'condition',
    label: '关键字',
    searchPlaceholder: '姓名、手机号、企业名称、部门'
  },
  column: [{
      label: '',
      prop: 'id',
      width: 40,
      solt: true
    },
    {
      label: '员工姓名',
      minWidth: 120,
      prop: 'name',
      overHidden: true
    }, {
      label: '手机号码',
      minWidth: 110,
      prop: 'phone'
    }, {
      label: '企业名称',
      prop: 'companyName',
      overHidden: true
    }, {
      label: "所属部门",
      prop: "deptName",
      type: "tree",
      span: 24,
      dicUrl: '/dept/tree',
      dicMethod: "post",
      dicQuery: objKeySort({}),
      props: {
        label: 'name',
        value: 'id'
      }
    }, {
      label: '是否加入企业',
      minWidth: 120,
      prop: 'companyAuthStatus',
      formatter: companystate
    }, {
      label: '状态',
      minWidth: 60,
      prop: 'status',
      type: 'select',
      search: true,
      dicData: [{
          label: '正常',
          value: 1
        },
        {
          label: '冻结',
          value: 2
        }
      ]
      // formatter: personnerstate
    }, {
      label: '状态',
      minWidth: 60,
      prop: 'status',
      type: 'input',
      search: true,

      // formatter: personnerstate
    }, {
      label: '注册时间',
      prop: 'createtime',
      type: 'date',
      minWidth: 160,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss'
    }
  ]
}



//设置管理员
export const personnelget = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 350,
  index: false,
  column: [{
      label: '',
      prop: 'id',
      width: 40,
      solt: true
    },
    {
      label: '员工姓名',
      prop: 'name',
      overHidden: true,
      search: true,
    }, {
      label: '手机号码',
      prop: 'phone',
      overHidden: true,
      search: true,
    }, {
      label: "所属部门",
      search: true,
      overHidden: true,
      prop: "deptName",
      type: "tree",
      span: 24,
      dicUrl: '/dept/tree',
      dicMethod: "post",
      dicQuery: objKeySort({}),
      props: {
        label: 'name',
        value: 'id'
      }
    }
  ]
}

//管理员转让列表
export const personnelchange = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: true,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 350,
  index: false,
  column: [{
      label: '',
      prop: 'id',
      width: 40,
      solt: true
    },
    {
      label: '员工姓名',
      prop: 'name',
      overHidden: true,
      search: true,
    }, {
      label: '手机号码',
      prop: 'phone',
      overHidden: true,
      search: true,
    }, {
      label: "所属部门",
      overHidden: true,
      prop: "deptName",
      type: "tree",
      span: 24,
      dicUrl: '/dept/tree',
      dicMethod: "post",
      dicQuery: objKeySort({}),
      props: {
        label: 'name',
        value: 'id'
      }
    }
  ]
}


//项目相关人员
export const personnelget1 = {
  addBtn: false,
  selection: true,
  tip: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  header: true,
  headerMenu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 500,
  index: false,
  column: [{
    label: '员工姓名',
    prop: 'name',
    overHidden: true,
  }, {
    label: '手机号码',
    prop: 'phone',
    search: false,
    overHidden: true,
  }, {
    label: "所属部门",
    search: false,
    prop: "deptName",
    type: "tree",
    overHidden: true,
    span: 24,
    dicUrl: '/dept/tree',
    dicMethod: "post",
    dicQuery: objKeySort({}),
    props: {
      label: 'name',
      value: 'id'
    }
  }]
}

//群组
export const groupqz = {
  addBtn: false,
  selection: true,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  header: false,
  headerMenu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 500,
  index: false,
  column: [{
    label: '群组名称',
    prop: 'groupName',
    overHidden: true,
  }, {
    label: '群组师傅数',
    prop: 'userCount',
    search: false,
    overHidden: true,
  }, {
    label: '群组描述',
    prop: 'groupTips',
    search: false,
    overHidden: true,
  }]
}


export const tableoptionworkers = {
  addBtn: false,
  selection: true,
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  menu: false,
  columnBtn: false,
  header: true,
  headerMenu: false,
  page: true,
  border: true,
  search: {
    prop: "condition",
    label: "师傅信息",
    searchPlaceholder: "请输入关键字"
  },
  align: "center",
  menuAlign: "center",
  height: window.innerHeight - 500,
  index: false,
  column: [{
      label: "手机号码",
      prop: "phone",
      overHidden: true
    },
    {
      label: "姓名",
      prop: "name",
      overHidden: true
    },
    {
      label: "团队认证",
      prop: "isForeman",
      search: true,
      type: "select",
      dicData: [{
          label: "已认证",
          value: 1
        },
        {
          label: "未认证",
          value: 0
        }
      ],
      overHidden: true,
      formatter: function(row) {
        return row.isForeman == 1 ? "已认证" : "未认证";
      }
    },
    {
      label: "工种",
      prop: "workTypeIds",
      type: "select",
      dicData: {},
      props: {
        label: "name",
        value: "id"
      },
      search: true,
      overHidden: true
    },
    {
      label: "实名状态",
      prop: "workerState",
      formatter: function(row) {
        if (row.workerState == 1) {
          return "审核中";
        } else if (row.workerState == 2) {
          return "已认证";
        } else {
          return "未认证";
        }
      }
    },
    {
      label: "群组",
      prop: "groupNames",
      overHidden: true,
      type: "select",
      props: {
        label: "groupName",
        value: "id"
      },
      search: true
    }
  ]
}



export const tableoptionwork = {
  addBtn: false,
  selection: true,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  header: false,
  headerMenu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 230,
  index: false,
  column: [{
      label: '手机号码',
      prop: 'phone',
      overHidden: true,
    },
    {
      label: '真实姓名',
      prop: 'name',
      overHidden: true,
    }, {
      label: '团队认证',
      prop: 'isForeman',
      overHidden: true,
      formatter: function(row) {
        return row.isForeman == 1 ? '已认证' : '未认证'
      }
    }, {
      label: '工种',
      prop: 'workTypeIds',
      overHidden: true
    }, {
      label: '实名状态',
      prop: 'workerState',
      formatter: function(row) {
        if (row.workerState == 1) {
          return "审核中";
        } else if (row.workerState == 2) {
          return "已认证";
        } else {
          return "未认证";
        }
      }
    }
  ]
}

function status(row) {
  return row.status == 1 ? '正常' : '冻结'
}

function Foremanstate(row) {
  return row.isForeman == 1 ? '已认证' : '未认证'
}

function isworkstate(row) {
  if (row.status == '1') {
    return '正常'
  } else if (row.status == '2') {
    return '冻结'
  }
}

function isworkerState(row) {
  if (row.workerState == '1') {
    return '审核中'
  } else if (row.workerState == '2') {
    return '已实名'
  } else if (row.workerState == '3') {
    return '已拒绝'
  } else {
    return '未实名'
  }
}

function conpamystate(row) {
  if (row.state == '1') {
    return '待审核'
  } else if (row.state == '2') {
    return '已认证'
  } else if (row.state == '3') {
    return '已拒绝'
  } else if (row.state >= 4) {
    return '已冻结'
  } else {
    return '未认证'
  }
}


function companystate(row) {
  if (row.companyAuthStatus == 1) {
    return "审核通过"
  } else if (row.companyAuthStatus == -1) {
    return "拒绝加入"
  } else {
    return "申请加入"
  }
}
function isAdminRoleFormatter(row) {
  if (row.isAdminRole == 1) {
    return "是"
  } else {
    return "否"
  }
}

//处理身份证号
function cardUser(row) {
  var carNum = '';
  if (row.cardNum && row.cardNum.length > 0) {
    let str = row.cardNum.split("");
    for (var i = 0; i < str.length; i++) {
      if (i < 6 || i >= str.length - 4) {
        carNum = carNum + str[i];
      } else {
        carNum = carNum + "*";
      }
    }
  }
  return carNum;
}
